import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { DashboardState, PanelConfig } from '../types/dashboard.types';

const initialState: DashboardState = {
  sidebarCollapsed: false,
  panels: [
    { id: 'info', title: 'Bảng thông tin', visible: true, position: 'right' },
    { id: 'stats', title: 'Số liệu tổng hợp', visible: true, position: 'left' },
    { id: 'legend', title: 'Chú giải', visible: true, position: 'right' },
  ],
  activeFilters: {},
  selectedItemId: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
    togglePanel(state, action: PayloadAction<string>) {
      const panel = state.panels.find((p) => p.id === action.payload);
      if (panel) panel.visible = !panel.visible;
    },
    updatePanel(state, action: PayloadAction<Partial<PanelConfig> & { id: string }>) {
      const panel = state.panels.find((p) => p.id === action.payload.id);
      if (panel) Object.assign(panel, action.payload);
    },
    setFilter(state, action: PayloadAction<{ key: string; value: unknown }>) {
      state.activeFilters[action.payload.key] = action.payload.value;
    },
    clearFilters(state) {
      state.activeFilters = {};
    },
    setSelectedItem(state, action: PayloadAction<string | null>) {
      state.selectedItemId = action.payload;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarCollapsed,
  togglePanel,
  updatePanel,
  setFilter,
  clearFilters,
  setSelectedItem,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
